/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'
import axios from 'axios'

import Signup3Doctor from '../../../../../presentation/pages/doctors/amplify/signup3'

import { makeSpecialties } from '../../../../usecases/specialties/remote-specialties-factory'
import { makeCities } from '../../../../usecases/cities/remote-cities-factory'
import { makeDoctorsRegister } from '../../../../usecases/doctors/remote-doctors-factory'

import { theme } from '../../../../../presentation/styles/theme'
import { RoutesEnum } from '../../../../../presentation/enums'

const initialStateAvailability = [
  {
    dayWeek: 'SUNDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'MONDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'TUESDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'WEDNESDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'THURSDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'FRIDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'SATURDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
]

const statesArray = [
  { id: '1', name: 'Acre' },
  { id: '2', name: 'Alagoas' },
  { id: '3', name: 'Amazonas' },
  { id: '4', name: 'Amapá' },
  { id: '5', name: 'Bahia' },
  { id: '6', name: 'Ceará' },
  { id: '7', name: 'Distrito Federal' },
  { id: '8', name: 'Espírito Santo' },
  { id: '9', name: 'Goiás' },
  { id: '10', name: 'Maranhão' },
  { id: '11', name: 'Minas Gerais' },
  { id: '12', name: 'Mato Grosso do Sul' },
  { id: '13', name: 'Mato Grosso' },
  { id: '14', name: 'Pará' },
  { id: '15', name: 'Paraíba' },
  { id: '16', name: 'Pernambuco' },
  { id: '17', name: 'Piauí' },
  { id: '18', name: 'Paraná' },
  { id: '19', name: 'Rio de Janeiro' },
  { id: '20', name: 'Rio Grande do Norte' },
  { id: '21', name: 'Rondônia' },
  { id: '22', name: 'Roraima' },
  { id: '23', name: 'Rio Grande do Sul' },
  { id: '24', name: 'Santa Catarina' },
  { id: '25', name: 'Sergipe' },
  { id: '26', name: 'São Paulo' },
  { id: '27', name: 'Tocantins' },
]

const optionsLocal = [
  { id: 1, nome: 'UPA' },
  { id: 2, nome: 'UBS' },
  { id: 3, nome: 'Hospitais' },
  { id: 4, nome: 'Plantão' },
  { id: 5, nome: 'Prefeituras' },
  { id: 6, nome: 'SAMU' },
  { id: 7, nome: 'Empresas' },
  { id: 8, nome: 'Clínicas do Trabalho' },
  { id: 9, nome: 'Clínicas de especialidades' },
  { id: 10, nome: 'Clínicas do DETRAN' },
  { id: 11, nome: 'Outros' },
]

const options = [
  {
    label: 'Domingo',
    subOptions: ['Dom/Manhã', 'Dom/Tarde', 'Dom/Noite'],
  },
  {
    label: 'Segunda',
    subOptions: ['Seg/Manhã', 'Seg/Tarde', 'Seg/Noite'],
  },
  {
    label: 'Terça',
    subOptions: ['Ter/Manhã', 'Ter/Tarde', 'Ter/Noite'],
  },
  {
    label: 'Quarta',
    subOptions: ['Qua/Manhã', 'Qua/Tarde', 'Qua/Noite'],
  },
  {
    label: 'Quinta',
    subOptions: ['Qui/Manhã', 'Qui/Tarde', 'Qui/Noite'],
  },
  {
    label: 'Sexta',
    subOptions: ['Sex/Manhã', 'Sex/Tarde', 'Sex/Noite'],
  },
  {
    label: 'Sábado',
    subOptions: ['Sab/Manhã', 'Sab/Tarde', 'Sab/Noite'],
  },
]

const MakeSignup3Doctor = (): JSX.Element => {
  window.dataLayer.push({
    event: 'signupDoctor3',
  })
  document.title = 'Buscar Médicos - Cadastro - Passo 3'

  const history = useHistory()

  const [errorMessage] = useState<string | null>('')

  const [specialtiesData, setSpecialtiesData] = useState<any>([])

  const [cities, setCities] = useState<Array<{ name: string; id: string }>>([])

  const [localBlock, setLocalBlock] = useState<any[]>([])

  const [city, setCity] = useState([])

  const [saveSpecialties, setSaveSpecialties] = useState<
    Array<{ label: string; value: string }>
  >([])

  const [selectedValues, setSelectedDates] = useState<
    Array<{
      dayWeek: string
      morning: boolean
      afternoon: boolean
      night: boolean
    }>
  >(initialStateAvailability)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await makeSpecialties().load()
        const specialities = response.content
          .filter((item: any) => item.active)
          .map((item: any) => ({
            key: String(item.id),
            id: String(item.id),
            nome: item.name,
            situação: item.enabled,
          }))
        setSpecialtiesData(specialities)
      } catch (error) {
        toast.error('Erro ao carregar especialidades.')
      }
    }

    fetchData()
  }, [])

  function handleUpdateSetCity(data: any) {
    const objetoArray = data.map((jsonString: any) => JSON.parse(jsonString))
    setCity(objetoArray)
  }

  async function handleSelectState(data: any) {
    try {
      if (data) {
        const response = await makeCities().loadById(data)
        const transformedResponse = response.map((cityOBJ: any) => ({
          ...cityOBJ,
          id: String(cityOBJ.id),
        }))
        setCities(transformedResponse)
      }
    } catch (error) {
      toast.error('Erro ao carregar dados pelo ID.')
    }
  }

  function handleSelectSpecialtie(data: any) {
    const objetoArray = data.map((jsonString: any) => JSON.parse(jsonString))
    setSaveSpecialties(objetoArray)
  }

  function handleSelectLocal(data: any) {
    const objetoArray = data.map((jsonString: any) => JSON.parse(jsonString))
    const hasOthersOption = objetoArray.some(
      (item: any) => item.nome === 'Outros',
    )

    if (!hasOthersOption) setLocalBlock(objetoArray)
  }

  const uploadCV = async (file: File) => {
    try {
      const userEmail = localStorage.getItem('userEmail')

      if (!userEmail) {
        throw new Error('E-mail não encontrado no localStorage')
      }

      if (file && !file.name.includes('.pdf')) {
        toast.error('Erro ao enviar currículo, formato não suportado. Use PDF.')
        return
      }

      const formData = new FormData()
      formData.append('file', new File([file], file.name))

      formData.append('email', userEmail)

      formData.append('type', 'application/pdf')

      const apiUrl = process.env.REACT_APP_API_URL

      const response = await axios.post(
        ` ${apiUrl}/public/register/doctor/upload-file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )

      // eslint-disable-next-line consistent-return
      return response.data
    } catch (error) {
      toast.error('Erro ao enviar CVm, formato não suportado.')
      throw error
    }
  }

  const handleRemoveSpecialty = (indexToRemove: number) => {
    setSaveSpecialties((prevSpecialties) => {
      const newSpecialties = [...prevSpecialties]
      newSpecialties.splice(indexToRemove, 1)
      return newSpecialties
    })
  }

  const handleRemoveCity = (indexToRemove: number) => {
    setCity((prevCities) => {
      const newCities = [...prevCities]
      newCities.splice(indexToRemove, 1)
      return newCities
    })
  }

  const handleRemoveLocal = (indexToRemove: number) => {
    setLocalBlock((prevLocal) => {
      const newLocal = [...prevLocal]
      newLocal.splice(indexToRemove, 1)
      return newLocal
    })
  }

  const handleSelectDates = (data: any) => {
    const isValidKey = (
      key: string,
      obj: Record<string, any>,
    ): key is keyof typeof obj => key in obj

    const dayWeekMapper: Record<string, string> = {
      Dom: 'SUNDAY',
      Seg: 'MONDAY',
      Ter: 'TUESDAY',
      Qua: 'WEDNESDAY',
      Qui: 'THURSDAY',
      Sex: 'FRIDAY',
      Sab: 'SATURDAY',
    }

    const periodMapper: Record<string, string> = {
      Manhã: 'morning',
      Tarde: 'afternoon',
      Noite: 'night',
    }

    const [dayWeek, period] = data.split('/')

    setSelectedDates((prevAvailability) => prevAvailability.map((day) => {
      if (
        day.dayWeek === dayWeekMapper[dayWeek]
          && period
          && isValidKey(period, periodMapper)
      ) {
        return {
          ...day,
          [periodMapper[period]]:
              !day[periodMapper[period] as keyof typeof day],
        }
      }
      return day
    }))
  }

  const dataForm = [
    {
      items: [
        {
          name: 'about',
          component: 'Textarea',
          title: 'Sobre',
          value: '',
          maxLenght: 5000,
          required: true,
          validations: 'inputRequired',
        },
        {
          component: 'SelectChecklist',
          title: 'Especialidades',
          name: 'specialties',
          required: true,
          validations: 'arrayRequired',
          placeholder: 'Especialidades',
          options: specialtiesData.map((option: any) => ({
            label: option.nome,
            value: JSON.stringify({ id: option.id, nome: option.nome }),
          })),
          onChange: handleSelectSpecialtie,
        },
        {
          component: 'Textline',
          title: saveSpecialties.map((option: any) => ({
            value: option.nome,
          })),
          handleClick: handleRemoveSpecialty,
        },
        {
          component: 'Select',
          title: 'Estado',
          name: 'states',
          required: true,
          placeholder: 'Selecione seu Estado',
          options: statesArray.map((option) => ({
            label: option.name,
            value: option.id,
          })),
          onChange: handleSelectState,
        },
        {
          component: 'SelectChecklist',
          name: 'cities',
          required: true,
          title: 'Cidades apto a trabalho',
          placeholder: 'Cidades apto a trabalho',
          options: cities.map((option) => ({
            label: option.name,
            value: JSON.stringify({ id: option.id, nome: option.name }),
          })),
          onChange: handleUpdateSetCity,
        },
        {
          component: 'Subtitle',
          title: 'Você pode adicionar quantas cidades achar necessário!',
          style: { color: `${theme.colors.gray500}` },
        },
        {
          component: 'Textline',
          title: city.map((option: any) => ({
            value: option.nome,
          })),
          handleClick: handleRemoveCity,
        },
        {
          component: 'SelectChecklist',
          name: 'workplace',
          required: true,
          placeholder: 'Locais de trabalho',
          options: optionsLocal.map((option: any) => ({
            label: option.nome,
            value: JSON.stringify({ id: option.id, nome: option.nome }),
          })),
          onChange: handleSelectLocal,
        },
        {
          component: 'Subtitle',
          title: 'Você pode adicionar quantos locais achar necessário!',
          style: { color: `${theme.colors.gray500}` },
        },
        {
          component: 'Textline',
          title: localBlock.map((option: any) => ({
            value: option.nome,
          })),
          handleClick: handleRemoveLocal,
        },
        {
          component: 'Title',
          title: 'Disponibilidade de dia e horário',
        },
        {
          name: 'dates',
          component: 'Multiselect',
          options,
          onSelect: handleSelectDates,
        },
        {
          component: 'Title',
          title: 'Anexe seu currículo',
        },
        {
          component: 'InputUpload',
          name: 'curriculum',
          description:
            'Sugerimos que envie seu arquivo em formato PDF / Tamanho máximo suportado 1MB',
          accept: '.pdf',
        },
        {
          name: 'observations',
          component: 'Textarea',
          title: 'Observações',
          value: '',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const hasAnyScheduleSelected = selectedValues.some((day) => {
    const { morning, afternoon, night } = day
    return morning || afternoon || night
  })

  const onSubmit = async (values: any): Promise<void> => {
    try {
      const userEmail = localStorage.getItem('userEmail')
      if (!userEmail) {
        throw new Error('E-mail não encontrado no localStorage')
      }

      if (!hasAnyScheduleSelected) {
        toast.error('Selecione ao menos um horário de disponibilidade.')
        return
      }

      const requestData = {
        email: userEmail,
        about: values.about,
        specialties: values.specialties.map((specialtyString: any) => {
          const parsedSpecialty = JSON.parse(specialtyString)
          return { id: parseInt(parsedSpecialty.id, 10) }
        }),
        availability: selectedValues,
        cities: values.cities.map((cityString: string) => {
          const cityObject = JSON.parse(cityString)
          return { id: parseInt(cityObject.id, 10) }
        }),
        workplace: localBlock.map((item: any) => item.nome),
        observation: values.observations,
      }

      await makeDoctorsRegister('step-three').post(requestData)

      if (values.curriculum) {
        await uploadCV(values.curriculum)
      }

      history.push(RoutesEnum.SIGNUP4_DOCTOR)
    } catch (error) {
      toast.error(
        'Erro ao enviar formulário, revise os campos e tente novamente.',
      )
    }
  }

  return (
    <Signup3Doctor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      options={options}
    />
  )
}

export default MakeSignup3Doctor
